import { translate } from '@vimeo/i18n-runtime';

import styles from './AlbumErrorState.module.scss';
import PasswordForm from './PasswordForm';
import TeamLogin from './TeamLogin';

// Values sourced from ~/controllers_v6/Next/EmbedController.php
const ALBUM_ENTERPRISE_LOGIN = 'enterprise_login';
const ALBUM_PRIVACY_PASSWORD = 'album_password';
const ERROR_ALBUM_NOT_FOUND = 404; // We are assuming a not-found error means the album was deleted
const ERROR_EMPTY_ALBUM = 'empty';
const ERROR_NOT_ACCESSIBLE = 'not_accessible';

const AlbumErrorState = ({
  error,
  errorBackground,
  handleChange,
  handleLogin,
  handleSubmit,
  invalidPassword,
  password,
  title,
  customLogo,
  color,
  sso,
}) => {
  const errorMessages = {
    deleted: translate('This album has been deleted.'),
    emptyShowcase: translate('This showcase is currently empty'),
    enterPassword: translate('Enter password to watch'),
    notAccessible: translate('Sorry, you don’t have permission to watch here.'),
  };

  let message;

  const isEmpty = error === ERROR_EMPTY_ALBUM;

  if (error === ERROR_ALBUM_NOT_FOUND) {
    message = errorMessages.deleted;
  }

  if (error === ERROR_NOT_ACCESSIBLE) {
    message = errorMessages.notAccessible;
  }

  if (error === ALBUM_PRIVACY_PASSWORD) {
    message = errorMessages.enterPassword;
  }

  if (error === ALBUM_ENTERPRISE_LOGIN) {
    return (
      <TeamLogin
        title={title}
        customLogo={customLogo}
        color={color}
        sso={sso}
        handleLogin={handleLogin}
      />
    );
  }

  if (isEmpty) {
    message = errorMessages['emptyShowcase'];
  }

  const containerStyles = errorBackground
    ? {
        background: `linear-gradient(rgba(255,255,255,0), rgba(0,0,0,1)), url(${JSON.stringify(
          errorBackground,
        )})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }
    : null;

  return (
    <div className={styles.errorState} style={containerStyles}>
      {error === ERROR_NOT_ACCESSIBLE ? (
        [
          <h1 className={styles.errorStateBigMessage} key="message-1">
            {translate('This is private')}
          </h1>,
          <h1 className={styles.errorStateMessage} key="message-2">
            {message}
          </h1>,
        ]
      ) : (
        <h1 className={styles.errorStateMessage}>{message}</h1>
      )}
      {/* Password form */}
      {error === ALBUM_PRIVACY_PASSWORD && (
        <PasswordForm
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          invalidPassword={invalidPassword}
          password={password}
        />
      )}
    </div>
  );
};

export default AlbumErrorState;
